import CartService from "@/services/Cart.js"

const state = {
    cart: null,
    voucherCheckinId: null,
    invoice: null,
}


const getters = {
    invoice: state => state.invoice
}


const mutations = {
    SET_CART(state, cart) {
        state.cart = cart
    },

    SET_VOUCHER_CHECKIN_ID(state, id) {
        state.voucherCheckinId = id
    },

    SET_INVOICE(state, invoice) {
        state.invoice = invoice
    },
    CLEAR_INVOICE(state) {
        state.invoice = null
    }
}


const actions = {
    // DEPRECATED: only fot voucher that are currently commented out
    getCart(context, params) {
        return CartService.getCart(params)
            .then(response => {
                context.commit('SET_CART', response.data)
                return response
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
